import api from "@/api";
import i18n from "@/i18n";
import VueCookies from "vue-cookies";

const defaultState = {
  loading: 0,
  sidebarStatus: false,
  menus: {},
  absoluteHeader: true,
  stores: {
    alb: "https://www.cityaventure.com/fr/shop-albigny/",
    steFoy: "https://www.cityaventure.com/fr/shop/",
    eg: "https://explorgameslyon.com/fr/"
    /*alb: "/",
    steFoy: "/",*/
  },
  resaStatus: false,
  submenus: {},
  popup: false,
  settings: null,
  winwheel: null,
  shopToast: false
};

const actions = {
  async fetchMenus(context) {
    let { data } = await api.get(`cdn/stories`, {
      starts_with: `${i18n.locale}/menus`
    });
    let menus = {};
    data.stories.map((story, index) => {
      menus[story.slug] = {
        slug: story.slug,
        items: story.content.items
      };
    });
    context.commit("SET_MENUS", menus);
  },
  async fetchWinwheel(context, app) {
    try {
      let winwheelResult = await api.get(`cdn/stories/${i18n.locale}/winwheel`);
      context.commit("SET_WINWHEEL", winwheelResult.data.story.content);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchSettings(context) {
    const { data } = await api.get(`cdn/stories/${i18n.locale}/settings`);
    context.commit("SET_SETTINGS", data.story.content);
  },
  async fetchSubmenus(context) {
    let { data } = await api.get(`cdn/stories`, {
      starts_with: `${i18n.locale}/submenus`
    });
    let submenus = {};
    data.stories.map((story, index) => {
      submenus[story.uuid] = {
        slug: story.slug,
        items: story.content.items
      };
    });
    context.commit("SET_SUBMENUS", submenus);
  }
};

const mutations = {
  SET_SIDEBAR_STATUS(state, payload) {
    state.sidebarStatus = payload;
  },
  SET_MENUS(state, payload) {
    state.menus = payload;
  },
  SET_SUBMENUS(state, payload) {
    state.submenus = payload;
  },
  SET_WINWHEEL(state, payload) {
    state.winwheel = payload;
  },
  LOADING(state, payload) {
    state.loading += parseInt(payload);
  },
  SET_RESA_STATUS(state, payload) {
    state.resaStatus = payload;
  },
  CLOSE_POPUP(state) {
    VueCookies.set("popupClosed", true, 60 * 60 * 24);
    state.popup = false;
  },
  SET_POPUP(state, payload) {
    state.popup = payload;
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
  SET_SHOP_TOAST(state, payload) {
    state.shopToast = payload;
  },
  TOGGLE_SHOP_TOAST(state) {
    state.shopToast = !state.shopToast;
  },
  CLOSE_SHOP_TOAST(state) {
    state.shopToast = false;
  },
  OPEN_SHOP_TOAST(state) {
    state.shopToast = true;
  }
};

const getters = {
  sidebarStatus(state) {
    return state.sidebarStatus;
  },
  menus(state) {
    return state.menus;
  },
  submenus(state) {
    return state.submenus;
  },
  absoluteHeader(state) {
    return state.absoluteHeader;
  },
  isLoading(state) {
    return state.loading > 0;
  },
  stores(state) {
    return state.stores;
  },
  resaStatus(state) {
    return state.resaStatus;
  },
  popup(state) {
    return state.popup;
  },
  settings(state) {
    return state.settings;
  },
  winwheel: state => {
    return state.winwheel;
  },
  shopToast: state => {
    return state.shopToast;
  }
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
